//import '../../../../styles/editor.scss';
import { Surface } from "@jsplumbtoolkit/browser-ui";
import { warn } from "@swivl-mono/helpers";
import { QuestInterface } from "@swivl-mono/types";
import { SearchInput } from "@swivl-mono/ui";
import React from "react";

import NodeModel from "../../Nodes/NodeModel";
import "./NodePalette.scss";
import NodePalletNodes from "./NodePalletNodes";

interface Props {
  surface: Surface;
  quest: QuestInterface;
}
interface State {
  searchQuery: string;
  mounted: boolean;
}
export default class NodePalette extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { searchQuery: "", mounted: false };
    this.dataGenerator = this.dataGenerator.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
  }
  dataGenerator(el: Element) {
    const model = NodeModel.forType(el.getAttribute("data-node-type"));
    if (!model) {
      warn("No node model for type", el, el.getAttribute("data-node-type"));
      return;
    }
    const node = model.PlumbData(model.Empty()).node;
    this.setState({ searchQuery: "" });
    return node;
  }
  componentDidMount(): void {
    this.setState({ mounted: true });
  }
  onSearchChange(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ searchQuery: event.target.value });
  }
  render() {
    const { surface, quest } = this.props;
    const { searchQuery, mounted } = this.state;

    return (
      <div className="NodePalette" id="NodePallete">
        <h3>Node Library</h3>
        <SearchInput value={searchQuery} onChange={this.onSearchChange} onClear={() => this.setState({ searchQuery: "" })} placeholder="Search..." />
        <div className="nodeList mt-2" id="NodePalleteNodes">
          {mounted && (
            <NodePalletNodes
              quest={quest}
              searchQuery={searchQuery}
              surface={surface}
              selector={"div"}
              container={document.getElementById("NodePalleteNodes")!}
              dataGenerator={this.dataGenerator}
            />
          )}
        </div>
      </div>
    );
  }
}
